// extracted by mini-css-extract-plugin
export default {"container":"PokemonListPage_container__vQyXP","container-image":"PokemonListPage_container-image__KSSXa","text-container":"PokemonListPage_text-container__RRG40"};